







































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import ApiFactory from "@/api/ApiFactory";
import { PerformanceChartDataDto } from "@/api/ClientPortalApiClient";
import { UserStore, LoadingSpinnerService } from "@/store";

@Component
export default class PolicyOverallReturn extends Vue {
  @Prop() id: number | undefined;

  private performanceChartData: PerformanceChartDataDto | null = null;
  private showIndividualFunds: boolean = false;
  private noData: boolean = false;

  async mounted() {
    await this.getFundPerformance();
  }

  private async getFundPerformance() {
    if (!this.id) throw new Error("Type id not valid");
    const api = ApiFactory.CreateDataClient();
    try {
      const perfData = await api.funds_GetOverallFundValuePerformance(
        UserStore.profileId,
        this.id
      );
      if (perfData) {
        this.performanceChartData = perfData;
      } else {
        this.noData = true;
      }
    } catch (e) {
      this.noData = true;
    }
  }
}
